'use client';

import { useCommonLayout } from '@musinsa/mds-ui';
import { useDeviceInfo } from '@musinsa/packages-device-detection';
import { useMemo } from 'react';
import { FloatingButtonGroup, PageViewTracker, ScrollToTopButton } from '../../common/components';
import { CampaignCategoryChips, useCampaignCategory } from './CampaignCategoryChips';
import {
  CampaignRecruitmentFilterRow,
  useLikedBrandsOnly,
  useRecruitmentColumns,
  useRecruitmentSort,
} from './CampaignRecruitmentFilterRow';
import { CampaignRecruitmentGrid } from './CampaignRecruitmentGrid';

export const CampaignRecruitmentPageView = () => {
  const { isMobile } = useDeviceInfo();
  const isPC = !isMobile;

  const containers = useMemo<['gnb', 'fab', 'header']>(() => ['gnb', 'fab', 'header'], []);
  const options = useMemo(
    () => ({
      ...(isPC ? { contentSize: 'max600' as const } : {}),
      appbar: {
        use: true,
        useBackButton: true,
        title: '캠페인 신청',
      },
      gnb: { use: isPC },
      fab: { use: false },
    }),
    [isPC],
  );

  useCommonLayout({ containers, options, isPcEnvironment: isPC });

  const [category] = useCampaignCategory();
  const [likedBrandsOnly] = useLikedBrandsOnly();
  const [sort] = useRecruitmentSort();
  const [columns] = useRecruitmentColumns();

  return (
    <div className="flex flex-col flex-1 bg-gray-100">
      {/* 시딩 캠페인 리스트 screen 진입 — 무신사 Amplitude (amp-seeding-list.md no.0).
          29CM Snowplow view_page 는 pageName 으로 동시 발화. */}
      <PageViewTracker
        pageName="curator_seeding_campaign_list"
        musinsaPageName="screen_curator_seeding_campaign_list"
      />
      <CampaignCategoryChips />
      <CampaignRecruitmentFilterRow />
      <CampaignRecruitmentGrid
        category={category || undefined}
        likedBrandsOnly={likedBrandsOnly || undefined}
        sort={sort}
        columns={columns}
      />
      {/* 상단 이동 플로팅 버튼 — 스크롤 시 노출. (SID-4456) */}
      <FloatingButtonGroup.Layout>
        <FloatingButtonGroup.Container className="safe-area-bottom">
          <ScrollToTopButton />
        </FloatingButtonGroup.Container>
      </FloatingButtonGroup.Layout>
    </div>
  );
};
